import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Input,
  Button,
} from "reactstrap";
import { FaTrash } from "react-icons/fa";
import axios from "../../../../utills/api";
import { toast } from "react-toastify";

const API_BASE = "/menu";

const MenuCategoryModal = ({
  isOpen,
  toggle,
}) => {
  const [menu, setMenu] = useState([]);
  const [newMenu, setNewMenu] = useState("");

  const token = localStorage.getItem("token");

  const axiosConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const fetchMenu = async () => {
    try {
      const res = await axios.get(
        `${API_BASE}/menu-settings`,
        axiosConfig
      );

      setMenu(
        Array.isArray(res.data)
          ? res.data
          : []
      );
    } catch (err) {
      console.error(err);
      toast.error(
        "Failed to load categories"
      );
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchMenu();
    }
  }, [isOpen]);

  const handleCreateCategory = async () => {
    if (!newMenu.trim()) {
      return toast.warning(
        "Enter category name"
      );
    }

    try {
      const res = await axios.post(
        `${API_BASE}/menu-settings`,
        {
          name: newMenu,
        },
        axiosConfig
      );

      setMenu((prev) => [
        ...prev,
        res.data,
      ]);

      setNewMenu("");

      toast.success(
        "Category created successfully"
      );
    } catch (err) {
      console.error(err);

      toast.error(
        err.response?.data?.message ||
          "Failed to create category"
      );
    }
  };

  const handleDeleteCategory = async (
    id
  ) => {
    if (
      !window.confirm(
        "Delete this category?"
      )
    )
      return;

    try {
      await axios.delete(
        `${API_BASE}/menu-settings/${id}`,
        axiosConfig
      );

      setMenu((prev) =>
        prev.filter(
          (item) => item._id !== id
        )
      );

      toast.success(
        "Category deleted"
      );
    } catch (err) {
      console.error(err);

      toast.error(
        err.response?.data?.message ||
          "Failed to delete category"
      );
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      centered
    >
      <ModalHeader toggle={toggle}>
        Food Categories
      </ModalHeader>

      <ModalBody>
        <div
          className="mb-4 p-3 rounded"
          style={{
            backgroundColor: "#f8f9fa",
          }}
        >
          <h6>Create Category</h6>

          <Row className="mt-3">
            <Col md={9}>
              <Input
                placeholder="Enter category name"
                value={newMenu}
                onChange={(e) =>
                  setNewMenu(
                    e.target.value
                  )
                }
              />
            </Col>

            <Col md={3}>
              <Button
                color="success"
                className="w-100"
                onClick={
                  handleCreateCategory
                }
              >
                Create
              </Button>
            </Col>
          </Row>
        </div>

        <div
          className="p-3 rounded"
          style={{
            backgroundColor: "#f8f9fa",
          }}
        >
          <h6>
            Existing Categories
          </h6>

          {menu.length === 0 ? (
            <p className="text-muted mb-0">
              No categories found
            </p>
          ) : (
            <Row className="mt-3">
              {menu.map((item) => (
                <Col
                  md={6}
                  key={item._id}
                  className="mb-3"
                >
                  <div
                    style={{
                      position:
                        "relative",
                    }}
                  >
                    <Input
                      value={item.name}
                      readOnly
                    />

                    <FaTrash
                      style={{
                        position:
                          "absolute",
                        right: "10px",
                        top: "50%",
                        transform:
                          "translateY(-50%)",
                        color:
                          "#dc3545",
                        cursor:
                          "pointer",
                      }}
                      onClick={() =>
                        handleDeleteCategory(
                          item._id
                        )
                      }
                    />
                  </div>
                </Col>
              ))}
            </Row>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default MenuCategoryModal;